import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  data: {},
  bids: [],
  bidInfo: null,
  similar: [],
  bidMessage: null
}

const getInfoActions = generateActions('lots/single/GET_INFO')
const subscribeActions = generateActions('lots/single/SUBSCRIBE')
const getSimilarActions = generateActions('lots/single/GET_SIMILAR')
const finishBidActions = generateActions('lots/single/FINISH_BID')

export const getFullInfo = createAction(
  API_CONST,
  lotId => ({
    url: `lots/${lotId}`,
    actions: getInfoActions
  }),
  (lotId, options = {}) => ({ noRewrite: options.noRewrite || false })
)

export const getSimilar = createAction(
  API_CONST,
  lotId => ({
    actions: getSimilarActions,
    url: `lots/${lotId}/similar`
  })
)

export const subscribe = createAction(
  API_CONST,
  (lotId, flag) => ({
    method: 'POST',
    actions: subscribeActions,
    params: { doSubscribe: flag },
    url: `lots/${lotId}/subscribe`
  }),
  (lotId, flag) => ({ flag })
)

export const finishBid = createAction(
  API_CONST,
  (lotId, bidId) => ({
    actions: finishBidActions,
    url: `lots/${lotId}/bid/${bidId}`
  })
)

const reformatBids = (items = []) => items.map(item => ({
  _id: item._id,
  sum: item.value,
  date: item.created,
  name: item.user.name,
  targetId: item.user._id,
  isAnonymous: item.isAnonymous,
  userPaymentId: item.userPaymentId,
  currency: item.currency && item.currency.symbol
}))

export default handleActions({
  [getInfoActions[0]]: (state, { meta }) => meta.noRewrite ? ({ ...state }) : ({ ...initial }),
  [getInfoActions[1]]: (state, { payload }) => ({
    ...state,
    data: payload,
    bids: reformatBids(payload.bids)
  }),
  [subscribeActions[1]]: (state, { meta }) => ({ ...state, data: { ...state.data, isSubscribed: meta.flag } }),
  [getSimilarActions[1]]: (state, { payload = [] }) => ({
    ...state,
    similar: payload.map(lot => reformatLot(lot))
  }),
  //
  [finishBidActions[1]]: (state, { payload }) => {
    console.log(payload)
    return ({ ...state, bidMessage: payload.message || null })
  }
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/lots/single.js